import { NgModule } from '@angular/core';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';
import { HomepageLinkDirective } from '~shared/modules/homepage-navigator/homepage-link.directive';

@NgModule({
  declarations: [
    HomepageLinkDirective,
  ],
  exports: [
    HomepageLinkDirective
  ],
  providers: [
    HomepageNavigatorService,
  ]
})
export class HomepageNavigatorModule { }
